import React from 'react';

const CategoriesPage = () => (
  <>
    <p className="text">Under Construction</p>
  </>
);

export default CategoriesPage;
